import React, { Component } from "react";
import Icon from '@xo-union/tk-component-icons';

export default class FashionIcon extends Component {
  render() {
    return (
      <Icon
        aria-hidden={this.props.ariaHidden}
        aria-label={this.props.ariaLabel}
        className={`${this.props.iconCssName || ''} union-icon`}
        name={this.props.name}
        role={this.props.role}
        size={this.props.size}
      />
    )
  }
}
